import React from "react";
import { styled, css } from "styled-components";
import { Colors } from "../../../styles";
const Container = styled.div `
  display: flex;
  flex-direction: column;
  width: 100%;
  text-align: center;
`;
const DateContainer = styled.div `
  padding: 0.75rem 1rem 0.5rem;
`;
const Month = styled.p `
  margin: 0;
  font-size: 0.875rem;
  font-weight: 500;
  text-transform: capitalize;
`;
const Date = styled.p `
  margin: 0;
  font-size: 1.5rem;
  font-weight: 500;
`;
export const DescriptionContainer = styled.div `
  display: flex;
  justify-content: center;
  align-items: center;
  flex: 1;
  padding: 0.5rem 1rem;
  min-height: 51px;
  border-top: 1px solid
    ${({ isChecked }) => (!isChecked ? Colors.GRAY : Colors.PROFILE_RED_2024)};

  ${({ highlighted }) => highlighted &&
    css `
      background: ${Colors.PROFILE_RED_2024};
      border-radius: 0 0 5px 5px;
      border-top: 1px solid ${Colors.PROFILE_RED_2024};
    `}

  > p {
    margin: 0;
    font-size: 0.75rem;
    font-weight: 500;
    color: ${({ highlighted }) => highlighted ? Colors.WHITE_2024 : Colors.GRAY_DARK};
  }
`;
const OrderDateRadioBoxHeader = ({ checked, date, description, highlighted, icon: Icon }) => (React.createElement(Container, null,
    React.createElement(DateContainer, null,
        Icon && React.createElement(Icon, { width: 35, height: 35 }),
        React.createElement(Month, null, date.getMonth()),
        React.createElement(Date, { highlighted: highlighted }, date.getDate())),
    React.createElement(DescriptionContainer, { isChecked: checked, highlighted: highlighted },
        React.createElement("p", null, description))));
export default OrderDateRadioBoxHeader;
//# sourceMappingURL=OrderDateRadioBoxBody.js.map